import React, { CSSProperties, SyntheticEvent, useEffect, useMemo, useState } from "react";
import {
  Button,
  ButtonProps,
  Icon,
  Popup,
  Image,
  List,
  ListItem,
  ListIcon,
  ListContent,
  ListHeader,
  ListDescription,
  ListList,
  Label,
  Header,
} from "semantic-ui-react";

import { BranchType } from "./segmentTreeType";

export type SegmentTargetTreeType = {
  listTrees?: BranchType[];
  onAddNode?: (parentId: string) => void;
  onRemove?: (parentId: string) => void;
  onEditTress?: (id: string) => void;
  onSelectedSegmentId?: (id: string) => void;
  // selectedSegmentId: string;
                SegmentTargetSequence: any;
};


type SegmentTargetTreeChildProps = {
  key: string;
  node: BranchType;
  onAddNode?: (parentId: string) => void;
  onRemove?: (parentId: string) => void;
  onSelectedSegmentId?: (id: string) => void;
  isLast?: boolean;
  isFirst?: boolean;
  hideMap: { [key: string]: boolean };
  onToggle: (id: string) => void;
  maxLabelWidth?: number;
  // selectedSegmentId: string;
  SegmentTargetSequence: any;

} & Pick<SegmentTargetTreeType, "onEditTress">;

const ICON = {
  folder: "static/images/segmentTarget/segment-folder.png",
  edit: "static/images/segmentTarget/segment-edit.png",
  addSegment: "static/images/segmentTarget/new-segment.png",
  hideFolder: "static/images/segmentTarget/hide-folder.png",
  ShowAll: "static/images/segmentTarget/show-all-folder.png",
};

const STYLES = {
  treeLine: {
    position: "relative",
    paddingLeft: 24,
  } as CSSProperties,
  removeBt: {
    position: "absolute",
    top: 43,
    left: 43,
    zIndex: 20,
    color: "red",
    background: "transparent",
    border: "none",
    fontSize: "20px",
    margin: 0,
    padding: 0,
  } as CSSProperties,
  verticalLine: {
    position: "absolute",
    top: 0,
    left: 24,
    width: 0,
    height: "100%",
    borderLeft: "2px solid #ccc",
    zIndex: 0,
  } as CSSProperties,
  nodeContainer: {
    position: "relative",
    zIndex: 2,
    background: "#fff",
    paddingLeft: 4,
    marginLeft: 5,
    display: "flex",
  } as CSSProperties,
  nodeLabel: {
    display: "flex",
    alignItems: "center",
    borderRadius: "2px",
    padding: "0 14px",
    minWidth: "180px",
  } as CSSProperties,
  showFile: {
    transition: "transform 1s ease",
    width: "13px",
    color: "#757575",
  } as CSSProperties,
};



const SegmentTargetTreeChild = (props: SegmentTargetTreeChildProps) => {
  const isExpanded = !props.hideMap[props.node.id]
  let labelWidth = props.maxLabelWidth ? props.maxLabelWidth : 100;
  let childLength = 100;
  if (Array.isArray(props.node?.children) && props.node?.children?.length > 0) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    context.font = "14px Arial"; 
    const listWidth = (props.node?.children).map((node) =>
      Math.ceil(context.measureText(node.label).width)
    );
    childLength = Math.max(...listWidth);
  }

  return (
    <>
      <ListItem>
        <ListIcon>
          <div style={{ display: "flex", height: "100%", gap: "4px" }}>
            <div
              style={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",

                alignItems: "center",
              }}
            >
              <img width="25px" height="25px" src={ICON.folder} />

              {isExpanded && props.node?.children && props.node?.children?.length > 0 ? (
                <>
                  <div
                    style={{
                      textAlign: "center",
                      paddingBottom: "5px",
                      flexGrow: 1,
                      maxHeight: "4px",
                      width: "2px",
                      backgroundColor: "grey",
                    }}
                  />
                  <div style={{ margin: "2px 0px" }}>
                    <Icon
                      style={{ margin: 0, cursor: "pointer" }}
                      name="close"
                      color="red"
                      onClick={() => props.onRemove?.(props.node?.id || "")}
                    />
                  </div>
                  <div
                    style={{
                      textAlign: "center",
                      paddingBottom: "5px",
                      flexGrow: 1,
                      width: "2px",
                      backgroundColor: "grey",
                    }}
                  />
                </>
              ) : null}
            </div>
            { props.node.children && props.node.children?.length > 0 ? <div style={{ paddingTop: "5px", paddingLeft: "0px" }}>
              <Icon
                name="angle down"
                onClick={() => props.onToggle(props.node.id)}
                style={{
                  ...STYLES.showFile,
                  cursor:"pointer",
                  transform: isExpanded ? "rotate(0deg)" : "rotate(-90deg)",
                }}
              />
            </div> : null }
            
          </div>
        </ListIcon>
        <ListContent style={{ paddingLeft: 0 }}>
          <ListHeader style={{ alignItems: "center", display: "flex", gap: "8px" }}>
            <Label
              style={{ display: "inline-block", minWidth: `${labelWidth}px`, cursor:"pointer" }}
              {...((props.SegmentTargetSequence.selectedSegmentId === props.node.id) && {color: "pink"})}
              onClick={() => {
                if (props.SegmentTargetSequence.selectedSegmentId === props.node.id) {
                  props.onSelectedSegmentId?.("")
                } else {
                  props.onSelectedSegmentId?.(props.node.id)
                }
              }}
              content={props.node.label}
            ></Label>{" "}
            {props.isFirst ? <img
              style={{ cursor: "pointer" }}
              height="25px"
              width="25px"
              src={ICON.edit}
              onClick={() => props.onEditTress?.(props.node.id)}
            /> : null}
            { !("children" in props.node) ? <img
              style={{ cursor: "pointer" }}
              height="25px"
              width="25px"
              src={ICON.addSegment}
              onClick={() => props.onAddNode?.(props.node.id)}
            /> : null }
            
          </ListHeader>
          <ListDescription>
            <Header
              as="h6"
              style={{ minWidth: `${labelWidth}px`, paddingLeft: "10px", color: "grey" }}
            >
              {props.node.description}
              {props.node.id}
            </Header>{" "}
          </ListDescription>
          { isExpanded && (props.node.children || []).map((items: BranchType, index: number) => (
            <ListList style={{ padding: ".75em 0 0 .5em" }}>
              {/* {props.node.children && props.node.children.length > 0 && !props.isFirst && (
                  <Button
                    onClick={() => props.onToggle(props.node.id)}
                    style={{
                      width: 22,
                      height: 22,
                      marginRight: 2,
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      fontSize: 14,
                      fontWeight: "bold",
                      color: "#444",
                      padding: 0,
                      userSelect: "none",
                    }}
                    aria-label={isExpanded ? "ซ่อน" : "แสดง"}
                  >
                    <Icon
                      name="angle right"
                      style={{
                        ...STYLES.showFile,
                        transform: isExpanded ? "rotate(0deg)" : "rotate(90deg)",
                      }}
                    />
                  </Button>
                )} */}
              <SegmentTargetTreeChild
                key={items.id}
                node={items}
                onAddNode={props.onAddNode}
                onRemove={props.onRemove}
                onSelectedSegmentId={props.onSelectedSegmentId}
                SegmentTargetSequence={props.SegmentTargetSequence}
                isFirst={false}
                isLast={index === (props.node.children || []).length - 1}
                hideMap={props.hideMap}
                onToggle={props.onToggle}
                onEditTress={props.onEditTress}
                maxLabelWidth={childLength}
              />
            </ListList>
          ))}
        </ListContent>
      </ListItem>
    </>
    //   <div
    //     key={props.key}
    //     style={{

    //     ...STYLES.treeLine,
    //     ...(props.isFirst && { padding: "0px" }),
    //     ...(!props.isFirst && { paddingTop: "16px" }),
    //   }}
    // >
    //   {/* vertical line (ถ้าไม่ใช่ node สุดท้ายในชั้น) */}
    //   {props.node.children && props.node.children.length > 0 && isExpanded && (
    //     <div style={{ ...STYLES.verticalLine, height: !props.isLast ? "100%" : "35px" }} />
    //   )}
    //   <div style={{ ...STYLES.verticalLine, height: !props.isLast ? "100%" : "35px" }}></div>
    //   {props.node.children && props.node.children.length > 0 && (isExpanded || props.isFirst) && (
    //     <Button
    //       onClick={() => props.onRemove?.(props.node?.id || "")}
    //       style={{ ...STYLES.removeBt, ...(props.isFirst && { left: 19 }) }}
    //     >
    //       ×
    //     </Button>
    //   )}
    //   <div style={{ display: "flex", alignItems: "center", position: "relative" }}>
    //     {/* toggle */}

    //     <span style={STYLES.nodeContainer}>
    //       <Image src={ICON.folder} />
    //       <div style={{ ...STYLES.nodeLabel, ...(props.isFirst && { background: "#D9D9D9C9" }) }}>
    //         {props.node.label}
    //       </div>
    //       {props.isFirst && (
    //         <Image
    //           src={ICON.edit}
    //           style={{ marginLeft: "22px", width: "25px", height: "25px" }}
    //           onClick={() => props.onEditTress?.(props.node.id)}
    //         />
    //       )}
    //       <Image
    //         src={ICON.addSegment}
    //         onClick={() => props.onAddNode?.(props.node.id)}
    //         style={{ marginLeft: "13px", width: "25px", height: "25px" }}
    //       />
    //     </span>
    //   </div>
    //   {/* children */}
    //   {props.node.children && props.node.children.length > 0 && isExpanded && (
    //     <div>
    //       {(props.node.children || []).map((items: BranchType, index: number) => (
    //         <TreeNodeComponent
    //           key={items.id}
    //           node={items}
    //           onAddNode={props.onAddNode}
    //           onRemove={props.onRemove}
    //           isLast={index === (props.node.children || []).length - 1}
    //           expandedMap={expandedMap}
    //           onToggle={props.onToggle}
    //           onEditTress={props.onEditTress}
    //         />
    //       ))}
    //     </div>
    //   )}
    // </div>
  );
};

export default SegmentTargetTreeChild ;
